// Shared helper for voice/mic state logic.
// Determines when the UI should consider the session "Active" but not actually listening.
// isActivelyListening covers background wake-word mode (recognition running but isListening=false).
export function isActiveVoiceState({
  sessionActive,
  isMicMuted,
  isTalking,
  isThinking,
  isListening,
  isActivelyListening,
}) {
  return (
    !!sessionActive &&
    !isMicMuted &&
    !isTalking &&
    !isThinking &&
    !isListening &&
    !isActivelyListening
  );
}

